import { Box, SimpleGrid } from '@chakra-ui/react';
import { useCallback } from 'react';
import ListLoader from 'components/list/ListLoader';
import { useClient } from 'hooks/useClient';
import { useForfait } from 'hooks/useForfait';
import { useIntervention } from 'hooks/useIntervention';
import { useSite } from 'hooks/useSite';
import MaintenanceTable, { MaintenanceSource } from 'views/admin/maintenance/components/MaintenanceTable';

export default function Maintenance() {
  const { getSites, getSitesEtat } = useSite();
  const { getClients } = useClient();
  const { fetch: fetchForfaits } = useForfait();
  const { fetch: fetchInterventions } = useIntervention();
  const load = useCallback(async (): Promise<MaintenanceSource[]> => {
    const [sites, clients, forfaits, interventions, etats] = await Promise.all([
      getSites(),
      getClients(),
      fetchForfaits(),
      fetchInterventions(),
      getSitesEtat(),
    ]);
    return [{ sites, clients, forfaits, interventions, etats }];
  }, [getSites, getSitesEtat, getClients, fetchForfaits, fetchInterventions]);

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid mb='20px' columns={1} spacing={{ base: '20px', xl: '20px' }}>
        <ListLoader load={load}>{(data) => <MaintenanceTable source={data[0]} />}</ListLoader>
      </SimpleGrid>
    </Box>
  );
}
